<div class="modal-header">
  <h4 class="modal-title h1 pull-left">Confirm?</h4>
  <btn-close class="pull-right" (click)="modalRef.hide()"></btn-close>
</div>
<div class="modal-body">
  <p>Are you sure you want to fail {{ id }} ?
  </p>
</div>
<div class="modal-footer border-0" [formGroup]="form" (submit)="confirm()">
  <button class="btn btn-danger mr-2"
          type="submit"
          (click)="confirm()">Confirm</button>
  <button class="btn btn-outline-info" (click)="this.modalRef.hide(); cancel()">Cancel</button>
</div>
